import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VisitPackageModalPage } from './visit-package-modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    VisitPackageModalPage,
  ],
  imports: [
    IonicPageModule.forChild(VisitPackageModalPage),
    TranslateModule.forChild()
  ],
})
export class VisitPackageModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/visit-package-modal/visit-package-modal.module.ts